export class AppIsOutdatedEvent {
  constructor() {}
}
